import { axios } from '@/utils/request'

export function getBranches() {
    return axios({
        baseURL: '/api/wx',
        url: '/branch/list',
        method: 'get',
    })
}

export function getBranchTop(branch_id){
    return axios({
        baseURL: '/api/wx',
        url: '/top/branch',
        method: 'get',
        params:{
            branch_id
        }
    })
}